import autobind from 'class-autobind';

import EventTarget from '@/util/EventTarget.js'
import { findUpTagByClass } from '@/util/findUpTag.js'

import SelectHandler from '@/toolHandler/SelectHandler/SelectHandler';


class PanHandler {
    constructor(host) {
        autobind(this);

        this.host = host;
    }

    startdrag(event){
        // console.log('EVENT:', 'start drag', event.detail);
        this.host.gestureStartScale = this.host.current.scale;


        let gestureTarget = event.detail.gestureStartTarget;

        const textfieldElement = findUpTagByClass(gestureTarget, 'Textfield');
        const isTextfield = textfieldElement !== null;
        if (isTextfield) {
            gestureTarget = textfieldElement;
        }
        // console.log('isTextfield', isTextfield, textfieldElement);
        

        const isDraggable = gestureTarget && gestureTarget.classList.contains('draggable');

        if (gestureTarget) {
            // const isTriggersDeselect = gestureTarget ? (gestureTarget.className.split(' ').indexOf('grid') !== -1) : false;
            const id = gestureTarget.id;
            const alreadySelected = this.host.props.content.selection.indexOf(id) !== -1;
            if (isDraggable && !alreadySelected) {
                //this.state.multiselect ||
                if (this.host.props.multiselect) {
                    console.log("TOGGLE SEL! B")
                    this.toggleSelection(gestureTarget.id);
                } else {
                    // console.log("SET SEL GESTURE! B", this)
                    // this.host.props.setSelection([gestureTarget.id]);
                }
                // this.props.editSelected();
                // self.props.setSelection(e.target.id);
            }
        }
        
        this.host.handleGestureChanged(event);
    }

    change(event) {
        const dx = event.detail.delta.pos.x / this.host.current.scale;
        const dy = event.detail.delta.pos.y / this.host.current.scale;

        const isTextfieldSelected = this.host.props.content.selection.length == 1 
        && 
        this.host.props.content.media.find((x)=>{return x.id == this.host.props.content.selection[0]}).type == 'text';


        const isActiveTextfieldSelected = isTextfieldSelected 
        &&  this.host.props.content.selection[0] == this.host.props.content.active[0];

        let gestureTarget = event.detail.gestureStartTarget;

        const textfieldElement = findUpTagByClass(gestureTarget, 'Textfield');
        const isTextfield = textfieldElement !== null;
        if (isTextfield) {
            gestureTarget = textfieldElement;
        }
        // console.log('isTextfield', isTextfield, textfieldElement);
        

        const isDraggable = gestureTarget && gestureTarget.classList.contains('draggable');

        if (gestureTarget) {
            // const isTriggersDeselect = gestureTarget ? (gestureTarget.className.split(' ').indexOf('grid') !== -1) : false;
            const id = gestureTarget.id;
            const alreadySelected = this.host.props.content.selection.indexOf(id) !== -1;

            if (alreadySelected && !isActiveTextfieldSelected && isDraggable && (dx !== 0 || dy !== 0)) {
                this.host.didDrag =  true;
                console.log('drag')
                this.host.props.moveSelection(
                    dx,
                    dy
                );
            } else {
                // console.log("[[[  HELP!  ]]]", event)
                this.host.didDrag =  false;

                this.host.eventTarget.dispatchEvent(new CustomEvent('pan-by', {
                    detail: {
                        dx: event.detail.delta.pos.x,
                        dy: event.detail.delta.pos.y
                    }
                }));

                // this.host.directed.x += dx;
                // this.host.directed.y += dy;
            }
        }
    }

};

PanHandler.prototype.tap = SelectHandler.prototype.tap
// PanHandler.prototype.startdrag = SelectHandler.prototype.startdrag

console.log('PanHandler', PanHandler);

export default PanHandler;
